export const TRANSLATIONS_ROUTE_NAMES = {
    LIST: "TranslationsList",
    CREATE: "TranslationsAdd",
    EDIT: "TranslationsSingle",
};
